import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { environment } from "../../../../../environments/environment";
import { SiilaTranslationService } from "../../../../core/services/siila-translation.service";
import { Location } from "@angular/common";

@Component({
  selector: "privacy-policy",
  templateUrl: "./privacy-policy.component.html",
  styleUrls: ["./privacy-policy.component.scss"]
})
export class PrivacyPolicyComponent implements OnInit {
  browserLang: string = "pt";
  routerSub: Subscription;
  currentEnv: string;
  constructor(
    private siilaTranslationService: SiilaTranslationService,
    private route: ActivatedRoute,
    private location: Location
  ) {
    this.browserLang = this.siilaTranslationService.getCurrentLanguage();
    this.currentEnv = environment.platformId;
  }

  ngOnInit(): void {
    this.routerSub = this.route.paramMap.subscribe(params => {
      this.browserLang = params.get("lang");
      if (this.browserLang !== undefined && this.browserLang !== null) {
        this.siilaTranslationService.setLanguage(
          this.browserLang == undefined ? "en" : this.browserLang
        );
        this.location.replaceState("/privacy-policy");
      }
    });
  }
}
